import app from 'app-entrypoint';

if (typeof app === 'function') {
  app();
}



//////////////////
// WEBPACK FOOTER
// /Users/anniedaniel/Desktop/trib/primary-early-vote-tracker-2018/config/entry.js
// module id = null
// module chunks = 